import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import get from 'lodash/get';

import {
  fragments as filterFragments,
  inventoryItemIsSafe
} from '../../../lib/filters';

const TOPIC_PRODUCT_FRAGMENT = gql`
  fragment TopicProductFields on TopicProductRecommendationList {
    topic
    iaCode
    iaDescription(locale: $locale)
  }
`;

export const topicProductRecommendationListCollectionQuery = (
  customFragments = []
) => {
  const allFragments = [...filterFragments, ...customFragments];
  const inventoryItemFragments = allFragments.filter(
    ({ type }) => type === 'ihs_InventoryItemsItem'
  );

  return gql`
    query topicProductRecommendationCollection(
      $limit: Int = 24,
      $locale: String!,
      $guruLocale: guru_Locale!
      $country: String!,
      $currency: String!,
      $topicLimit: Int = 1,
    ) {
      topicProductRecommendationListCollection(limit: $limit, locale: $guruLocale, topicLimit: $topicLimit) {
        ...TopicProductFields
        ${
          inventoryItemFragments.length > 0
            ? `
        inventoryItems(
          country: $country,
          currency: $currency,
          locale: $locale,
          unit: IN,
          previewTypeIds: ["product_close"]
        ) {
          ${inventoryItemFragments.map(({ name }) => `...${name}`).join('\n')}
        }
        `
            : ''
        }
      }
    }
    ${TOPIC_PRODUCT_FRAGMENT}
    ${inventoryItemFragments.reduce(
      (acc, { fragment }) => gql`
        ${acc}
        ${fragment}
      `,
      ''
    )}
  `;
};

export const useTopicProductRecommendationsCollection = ({
  country,
  currency,
  locale,
  topicLimit,
  fragments
}) => {
  const { data, loading, error } = useQuery(
    topicProductRecommendationListCollectionQuery(fragments),
    {
      variables: {
        limit: 24,
        locale,
        guruLocale: locale,
        country,
        currency,
        topicLimit
      },
      skip: !(country && currency && locale),
      ssr: false
    }
  );

  const collection = get(
    data,
    'topicProductRecommendationListCollection',
    []
  ).map(({ inventoryItems, ...rest }) => ({
    ...rest,
    items: inventoryItems.filter(inventoryItemIsSafe)
  }));

  return { loading, error, collection };
};

export default useTopicProductRecommendationsCollection;
